<div class="store-hours-menu-block">
    <div class="flex flex-row">
        <div class="store-hours-menu-link" (click)="changeHoursMenuTab(hoursMenuTab.OperationHours)"
             [class]="(activeHoursMenuTab === hoursMenuTab.OperationHours) ? 'hours-menu-link-active' : ''">Operation Hours</div>
        <div class="store-hours-menu-link" (click)="changeHoursMenuTab(hoursMenuTab.SpecialHours)"
             [class]="(activeHoursMenuTab === hoursMenuTab.SpecialHours) ? 'hours-menu-link-active' : ''">Special Hours</div>
    </div>
</div>
<div *ngIf="activeHoursMenuTab === hoursMenuTab.OperationHours" class="p-5">
    <div class="operation-hours-block">
        <p-selectButton [options]="daysWeek" [(ngModel)]="operationHours[0].SelectedDaysWeek" class="select-week"
                        [multiple]="true" optionLabel="name" optionValue="value"></p-selectButton>

        <div class="flex flex-row">
            <div class="col-4 p-0">
                <div class="store-hours-field">
                    <div class="store-hours-field__label">Start time</div>
                    <p-calendar [showTime]="true" [timeOnly]="true" hourFormat="12"
                                [(ngModel)]="operationHours[0].SelectStartTime"
                                placeholder="Select Start Time"></p-calendar>
                </div>
            </div>
            <div class="col-1 hours-delimiter">--</div>
            <div class="col-4 p-0">
                <div class="store-hours-field">
                    <div class="store-hours-field__label">End time</div>
                    <p-calendar [showTime]="true" [timeOnly]="true" hourFormat="12"
                                [(ngModel)]="operationHours[0].SelectEndTime"
                                placeholder="Select End Time"></p-calendar>
                </div>
            </div>
        </div>
    </div>

    <div class="operation-hours-block" *ngFor="let operationHour of operationHours.slice(1); let i = index;">
        <p-selectButton [options]="daysWeek" [(ngModel)]="operationHour.SelectedDaysWeek" class="select-week"
                        [multiple]="true" optionLabel="name" optionValue="value"></p-selectButton>

        <div class="flex flex-row">
            <div class="col-4 p-0">
                <div class="store-hours-field">
                    <div class="store-hours-field__label">Start time</div>
                    <p-calendar [showTime]="true" [timeOnly]="true" hourFormat="12"
                                [(ngModel)]="operationHour.SelectStartTime"
                                placeholder="Select Start Time"></p-calendar>
                </div>
            </div>
            <div class="col-1 hours-delimiter">--</div>
            <div class="col-4 p-0">
                <div class="store-hours-field">
                    <div class="store-hours-field__label">End time</div>
                    <p-calendar [showTime]="true" [timeOnly]="true" hourFormat="12"
                                [(ngModel)]="operationHour.SelectEndTime"
                                placeholder="Select End Time"></p-calendar>
                </div>
            </div>
            <div class="col-2 p-0 store-delete-operation-hour-object" (click)="deleteOperationHour(i + 1)">
                Delete
            </div>
        </div>
    </div>

    <div class="add-block-operation-hours-link" (click)="addOperationHour()">Add more days and times</div>
</div>

<div *ngIf="activeHoursMenuTab === hoursMenuTab.SpecialHours" class="p-4">
    <div class="operation-hours-block">
        <div class="store-hours-field">
            <div class="store-hours-field__label">Special hours desription</div>
            <input type="text" [(ngModel)]="specialHours[0].Title" placeholder="E.g Chinese New Year" pInputText />
        </div>

        <div class="store-hours-field">
            <div class="flex flex-row">
                <div class="col-5 p-0">
                    <div class="store-hours-field">
                        <div class="store-hours-field__label">Start date</div>
                        <p-calendar [(ngModel)]="specialHours[0].StartDate" placeholder="Select date"></p-calendar>
                    </div>
                </div>
                <div class="col-2 hours-delimiter">--</div>
                <div class="col-5 p-0">
                    <div class="store-hours-field">
                        <div class="store-hours-field__label">End date</div>
                        <p-calendar [(ngModel)]="specialHours[0].EndDate" placeholder="Select date"></p-calendar>
                    </div>
                </div>
            </div>
        </div>

        <div class="store-hours-field">
            <p-inputSwitch [(ngModel)]="specialHours[0].IsOpen"></p-inputSwitch> <span>{{(specialHours[0].IsOpen) ? 'Open' : 'Close'}}</span>
        </div>

        <div class="store-hours-field">
            <div class="flex flex-row">
                <div class="col-3 p-0">
                    <div class="store-hours-field">
                        <div class="store-hours-field__label">Opens at</div>
                        <p-calendar [showTime]="true" [(ngModel)]="specialHours[0].StoreSpecialHourTimes[0].OpensAt"
                                    [timeOnly]="true" hourFormat="12"></p-calendar>
                    </div>
                </div>
                <div class="col-1 hours-delimiter">--</div>
                <div class="col-3 p-0">
                    <div class="store-hours-field">
                        <div class="store-hours-field__label">Closes at</div>
                        <p-calendar [showTime]="true" [(ngModel)]="specialHours[0].StoreSpecialHourTimes[0].ClosesAt"
                                    [timeOnly]="true" hourFormat="12"></p-calendar>
                    </div>
                </div>
                <div class="col-1 store-time-add-btn" (click)="addSpecialTime(specialHours[0])">
                    <img src="/XpressApp/assets/images/store/add-plus-circle-small.svg" />
                </div>
            </div>
        </div>
        <div class="store-hours-field" *ngFor="let time of specialHours[0].StoreSpecialHourTimes.slice(1); let i = index;">
            <div class="flex flex-row">
                <div class="col-3 p-0">
                    <div class="store-hours-field">
                        <div class="store-hours-field__label">Opens at</div>
                        <p-calendar [showTime]="true" [(ngModel)]="time.OpensAt"
                                    [timeOnly]="true" hourFormat="12"></p-calendar>
                    </div>
                </div>
                <div class="col-1 hours-delimiter">--</div>
                <div class="col-3 p-0">
                    <div class="store-hours-field">
                        <div class="store-hours-field__label">Closes at</div>
                        <p-calendar [showTime]="true" [(ngModel)]="time.ClosesAt"
                                    [timeOnly]="true" hourFormat="12"></p-calendar>
                    </div>
                </div>
                <div class="col-1 store-time-add-btn">
                    <i class="pi pi-minus-circle store-hour-delete-icon" (click)="deleteSpecialTime(specialHours[0], i + 1)"></i>
                </div>
            </div>
        </div>
    </div>

    <div class="operation-hours-block" *ngFor="let specialHour of specialHours.slice(1); let i = index;">
        <div class="delete-special-hour-block">
            <div class="delete-special-hour-block__link" (click)="deleteSpecialHour(i + 1)">
                Delete
            </div>
        </div>
        <div class="store-hours-field">
            <div class="store-hours-field__label">Special hours desription</div>
            <input type="text" [(ngModel)]="specialHour.Title" placeholder="E.g Chinese New Year" pInputText />
        </div>

        <div class="store-hours-field">
            <div class="flex flex-row">
                <div class="col-5 p-0">
                    <div class="store-hours-field">
                        <div class="store-hours-field__label">Start date</div>
                        <p-calendar [(ngModel)]="specialHour.StartDate" placeholder="Select date"></p-calendar>
                    </div>
                </div>
                <div class="col-2 hours-delimiter">--</div>
                <div class="col-5 p-0">
                    <div class="store-hours-field">
                        <div class="store-hours-field__label">End date</div>
                        <p-calendar [(ngModel)]="specialHour.EndDate" placeholder="Select date"></p-calendar>
                    </div>
                </div>
            </div>
        </div>

        <div class="store-hours-field">
            <p-inputSwitch [(ngModel)]="specialHour.IsOpen"></p-inputSwitch> <span>{{(specialHour.IsOpen) ? 'Open' : 'Close'}}</span>
        </div>

        <div class="store-hours-field">
            <div class="flex flex-row">
                <div class="col-3 p-0">
                    <div class="store-hours-field">
                        <div class="store-hours-field__label">Opens at</div>
                        <p-calendar [showTime]="true" [(ngModel)]="specialHour.StoreSpecialHourTimes[0].OpensAt"
                                    [timeOnly]="true" hourFormat="12"></p-calendar>
                    </div>
                </div>
                <div class="col-1 hours-delimiter">--</div>
                <div class="col-3 p-0">
                    <div class="store-hours-field">
                        <div class="store-hours-field__label">Closes at</div>
                        <p-calendar [showTime]="true" [(ngModel)]="specialHour.StoreSpecialHourTimes[0].ClosesAt"
                                    [timeOnly]="true" hourFormat="12"></p-calendar>
                    </div>
                </div>
                <div class="col-1 store-time-add-btn">
                    <img src="/XpressApp/assets/images/store/add-plus-circle-small.svg" (click)="addSpecialTime(specialHour)" />
                </div>
            </div>
        </div>
        <div class="store-hours-field" *ngFor="let time of specialHour.StoreSpecialHourTimes.slice(1); let i = index;">
            <div class="flex flex-row">
                <div class="col-3 p-0">
                    <div class="store-hours-field">
                        <div class="store-hours-field__label">Opens at</div>
                        <p-calendar [showTime]="true" [(ngModel)]="time.OpensAt"
                                    [timeOnly]="true" hourFormat="12"></p-calendar>
                    </div>
                </div>
                <div class="col-1 hours-delimiter">--</div>
                <div class="col-3 p-0">
                    <div class="store-hours-field">
                        <div class="store-hours-field__label">Closes at</div>
                        <p-calendar [showTime]="true" [(ngModel)]="time.ClosesAt"
                                    [timeOnly]="true" hourFormat="12"></p-calendar>
                    </div>
                </div>
                <div class="col-1 store-time-add-btn">
                    <i class="pi pi-minus-circle store-hour-delete-icon" (click)="deleteSpecialTime(specialHour, i + 1)"></i>
                </div>
            </div>
        </div>
    </div>

    <div class="add-block-operation-hours-link" (click)="addSpecialHour()">Add more special hours</div>
</div>
